<template>
	<div class="index_body" id="top" :class="isPhone == 'true' ? 'mobile' : ''">
		<head-nav></head-nav>
		<div class="banner_box">
			<swiper ref="mySwiper" :options="swiperOptions">
				<swiper-slide class="swiper-slide">
					<div class="banner">
						<img src="@comm/images/document-conversion/home/banner1.png" alt />
							<div class="banner_btn">
								<div class="btn login_btn" @click="toguid('/electronicCertificate', 'public',1)">立即体验</div>
							</div>
					</div>
				</swiper-slide>
				<swiper-slide class="swiper-slide">
					<div class="banner">
						<img src="@comm/images/document-conversion/home/banner2.png" alt />
					</div>
				</swiper-slide>
				<swiper-slide class="swiper-slide">
					<div class="banner">
						<img src="@comm/images/document-conversion/home/banner3.png" alt />
							<div class="banner_btn">
								<div class="btn login_btn" @click="toguid('/onlinePreview/', 'public')">立即体验</div>
							</div>
					</div>
				</swiper-slide>
			</swiper>
			<div class="swiper-pagination" slot="pagination"></div>
		</div>
		<div class="change_list_box">
			<h2>文档格式转换</h2>
			<div class="change_list">
				<div class="item" :class="{ active: currentJump == 2 }"
					@click="jumpPage('/domConversionOfd/?type=ofdtopdf', 2)">
					<img src="@comm/images/document-conversion/homeSVG/nav_2.svg" alt />
					<h3>OFD转PDF</h3>
					<p>在线将OFD文件转换为PDF文件</p>
				</div>
				<div class="item" :class="{ active: currentJump == 6 }"
					@click="jumpPage('/domConversionOfd/?type=toofd', 2)">
					<img src="@comm/images/document-conversion/homeSVG/nav_6.svg" alt />
					<h3>Excel转OFD</h3>
					<p>在线将XLS、XLSX格式文件转换为OFD文件</p>
				</div>
				<div class="item" @click="jumpPage('/domConversionOfd/?type=toofd', 2)">
					<img src="@comm/images/document-conversion/homeSVG/nav_8.svg" alt />
					<h3>Word转OFD</h3>
					<p>在线将DOC、DOCX格式文件转换为OFD文件</p>
				</div>
				<div class="item" @click="jumpPage('/domConversionOfd/?type=toofd', 2)">
					<img src="@comm/images/document-conversion/homeSVG/nav_7.svg" alt />
					<h3>PPT转OFD</h3>
					<p>在线将PPT、PPTX格式文件转换为OFD文件</p>
				</div>
				<div class="item" :class="{ active: currentJump == 3 }"
					@click="jumpPage('/imgConversion/?type=toofd', 2)">
					<img src="@comm/images/document-conversion/homeSVG/nav_3.svg" alt />
					<h3>图片转OFD/PDF</h3>
					<p>支持将JPG、PNG、BMP、TIFF格式图片转换为OFD或者PDF文件</p>
				</div>
				<div class="item" :class="{ active: currentJump == 4 }"
					@click="jumpPage('/imgConversion/?type=toimg', 2)">
					<img src="@comm/images/document-conversion/homeSVG/nav_4.svg" alt />
					<h3>OFD/PDF转图片</h3>
					<p>将OFD/PDF文件的页面转换为多张图片或一张长图</p>
				</div>
				<div class="item" :class="{ active: currentJump == 1 }"
					@click="jumpPage('/domConversionOfd/?type=toofd', 2)">
					<img src="@comm/images/document-conversion/homeSVG/nav_1.svg" alt />
					<h3>其他转OFD</h3>
					<p>支持批量在线转换 & 同时合并为一个OFD文件</p>
				</div>
				<div class="item" :class="{ active: currentJump == 5 }"
					@click="jumpPage('/domConversionOfd/?type=topdf', 2)">
					<img src="@comm/images/document-conversion/homeSVG/nav_5.svg" alt />
					<h3>其他转PDF</h3>
					<p>支持批量在线转换 & 同时合并为一个PDF文件</p>
				</div>
			</div>
		</div>
		<div class="invoice_box">
			<div class="invoice_content">
				<div class="fonts">
					<h2>OFD电子发票应用</h2>
					<h5>助力企业快速、高效地生成OFD电子发票。</h5>
					<div class="list">
						<div class="item"><span><img src="@comm/images/document-conversion/home/middle_icon_1.png" alt /></span>轻松快速浏览</div>
						<div class="item"><span><img src="@comm/images/document-conversion/home/middle_icon_2.png" alt /></span>转PDF/图片</div>
						<div class="item"><span><img src="@comm/images/document-conversion/home/middle_icon_3.png" alt /></span>自动验证真伪</div>
						<div class="item"><span><img src="@comm/images/document-conversion/home/middle_icon_4.png" alt /></span>数据批量提取</div>
					</div>
					<div class="btn ty_btn" @click="toguid('/InApplication/', 'public',1)">立即体验</div>
					<p>服务热线：400-677-5005</p>
				</div>
			</div>
		</div>
		<div class="document_box">
			<h2>海量格式多端在线文档预览</h2>
			<div class="box">
				<img src="@comm/images/document-conversion/home/icon.png" alt class="icon"/>
				<div class="fonts">
					<div class="list">
						<div class="item"><span><img src="@comm/images/document-conversion/home/document_04.png" alt /></span>无需下载，即点即看</div>
						<div class="item"><span><img src="@comm/images/document-conversion/home/document_01.png" alt /></span>高速加载，原版呈现</div>
						<div class="item"><span><img src="@comm/images/document-conversion/home/document_03.png" alt /></span>文档安全，精准防护</div>
						<div class="item"><span><img src="@comm/images/document-conversion/home/document_02.png" alt /></span>海量用户，智慧之选</div>
					</div>
					<div class="btn ty_btn" @click="toguid('/onlinePreview/', 'public')">立即体验</div>
				</div>
			</div>
		</div>
		<div class="invoice_box pz_box">
			<div class="invoice_content">
				<div class="fonts">
					<h2>OFD电子凭证应用</h2>
					<h5>提供电子凭证模板制作、生成加工、预览验证、解析利用、XBRL封装提取等凭证全生命周期服务能力。</h5>
					<div class="list">
						<div class="item">符合标准</div>
						<div class="item">功能全面</div>
						<div class="item">稳定可靠</div>
						<div class="item">扩展性强</div>
						<div class="item">性能优越</div>
						<div class="item">精准解析</div>
					</div>
					<div class="btn ty_btn" @click="toguid('/electronicCertificate', 'public',1)">立即体验</div>
					<p>服务热线：400-677-5005</p>
				</div>
			</div>
		</div>
		<div id="downBox" class="zhanwei" name="downBox"></div>
		<div class="title">多端协作 免费下载</div>
		<div class="down_content_new">
			<a class="item" @mouseenter="isDownHover = true" @mouseleave="isDownHover = false">
				<div class="win_down">
					<img v-if="!isDownHover" src="@comm/images/document-conversion/homeSVG/svg_window.png" alt />
					<img v-else src="@comm/images/document-conversion/homeSVG/svg_window_hover.svg" alt />
					<div class="fonts">
						<h2>数科OFD阅读器Windows版</h2>
						<p><span>多格式支持</span><span>签批注释标记</span><span>签名盖章验证</span><span>票据助手</span></p>
					</div>
					<div class="right">
						<div class="list" @click="goDown(1)">Windows版下载</div>
						<div class="list" style="margin-bottom: 0;" @click="goDown(2)">Windows XP版下载</div>
					</div>
				</div>
			</a>
			<a class="item" @mouseenter="isAndroidHover = true" @mouseleave="isAndroidHover = false">
				<img v-if="!isAndroidHover" src="@comm/images/document-conversion/homeSVG/svg_android.png" alt />
				<img v-else src="@comm/images/document-conversion/homeSVG/svg_android_hover.svg" alt />
				<div class="fonts">
					<h2>数科OFD阅读器Android版</h2>
					<p><span>阅读/操作/注释</span><span>原笔迹签批</span><span>签名盖章验证</span><span>语义标引</span></p>
				</div>
				<div class="right">
					<img src="@comm/images/document-conversion/home/wechart_erweima.png" class="erweima" />
				</div>
			</a>
			<a class="item" @mouseenter="isIOSHover = true" @mouseleave="isIOSHover = false">
				<img v-if="!isIOSHover" src="@comm/images/document-conversion/homeSVG/svg_ios.png" alt />
				<img v-else src="@comm/images/document-conversion/homeSVG/svg_ios_hover.svg" alt />
				<div class="fonts">
					<h2>数科OFD阅读器ios版</h2>
					<p><span>发票夹/筛选/星标</span><span>验证发票真伪</span><span>文档页面处理</span><span>发票筛选管理</span></p>
				</div>
				<div class="right">
					<img src="@comm/images/document-conversion/home/wechart_erweima.png" alt class="erweima" />
				</div>
			</a>
			<a class="item" @mouseenter="isWXHover = true" @mouseleave="isWXHover = false">
				<img v-if="!isWXHover" src="@comm/images/document-conversion/homeSVG/svg_wx_mini.png" alt />
				<img v-else src="@comm/images/document-conversion/homeSVG/svg_wx_mini_hover.svg" alt />
				<div class="fonts">
					<h2>数科OFD微信小程序</h2>
					<p><span>跨平台无插件</span><span>文档安全阅读</span><span>签章验证</span><span>协同办公</span></p>
				</div>
				<div class="right">
					<img src="@comm/images/document-conversion/home/xiaochengxu.png" alt class="erweima" />
				</div>
			</a>
		</div>

		<customer-service></customer-service>
		<!-- footer -->
		<footer-nav></footer-nav>
	</div>
</template>

<script>
import headNav from "@comm/components/document-conversion/headerPage";
import footerNav from "@comm/components/document-conversion/footerPage";
import customerService from "@comm/components/document-conversion/customerService";
import { downPcReader } from "@comm/api/document-conversion";
export default {
	metaInfo: {
		title: '数科OFD在线体验中心，在线处理OFD文件，转换格式等',
		meta: [
			{
				name: 'keywords',
				content: 'OFD、OFD发票、OFD格式转换、查验OFD发票、打开OFD'
			},
			{
				name: 'description',
				content: '数科OFD体验中心，在线进行OFD文件的打开、打印、转换为PDF/图片、提取数据、验证OFD发票真伪等，同时支持海量格式在线预览。'
			}
		]
	},
	components: { footerNav, customerService, headNav },
	name: "index",
	data() {
		let self = this;
		return {
			currentJump: "",
			isPhone: "",
			isDownHover: false,
			isAndroidHover: false,
			isIOSHover: false,
			isWXHover: false,
			userInfor: {},
			winLink: "",
			andLink: "",
			scroll: "",
			local: false,
			timer: null,
			swiperOptions: {
				pagination: {
					el: ".swiper-pagination",
					clickable: true
				},
				loop: true, // 循环模式选项
				autoplay: {
					delay: 10000,
					disableOnInteraction:false
				}, // 自动播放
				speed: 2000, // 切换速度
				effect: "slide", // 动画 fade cube slide coverflow flip
				observer: true, // 修改swiper自己或子元素时，自动初始化swiper
				observeParents: true, // 修改swiper的父元素时，自动初始化swiper
				on: {
					click: function(event) {
						let dataset = event.target.dataset;
						if (dataset.class == "downWin") {
							self.goDown(1); // 点击read more时页面展开
						} else {

						}
					}
				}
			},
		};
	},
	created() {
		this.isPhone = localStorage.getItem("isPhone");
		document.title = "首页";
		this.$nextTick(() => {
			this.toScoll();
		});
	},
	mounted() {
		this.andLink = localStorage.andLink;
		this.winLink = localStorage.winLink;
		let _this = this;
		_this.$nextTick(function () {
			window.addEventListener("scroll", _this.handleScroll);
			setTimeout(() => {
				let targetbox = document.getElementById("downBox");
				localStorage.setItem("target", targetbox.offsetTop);
			});
		});
	},
	watch: {
	},
	computed: {},
	methods: {
		goDown(type) {
			if (this.timer) clearTimeout(this.timer);
			this.timer = setTimeout(() => {
				downPcReader({ dictionaryId: type == 1 ? "135" : "137" })
					.then((res) => { })
					.catch(() => { });
				window.open(type == 1 ? localStorage.winLink : localStorage.andLink, "_self");
			}, 300);
		},
		toguid(path, id,type) {
			localStorage.setItem('index', type)
			var path = path;
			var Id = id;
			localStorage.setItem("toId", Id);
			this.$router.push(path);
		},
		toScoll() {
			//查找存储的锚点id
			let Id = localStorage.getItem("toNavId");
			let toElement = document.getElementById(Id);
			//锚点存在跳转
			if (Id) {
				toElement.scrollIntoView();
				localStorage.removeItem("toNavId");
			}
		},
		jumpPage(path, type) {
			localStorage.setItem('index', type)
			this.currentJump = type;
			this.$router.push({ path: path });
		}
	}
};
</script>
<style lang="scss" scoped>
.down_content_new {
	position: relative;
	z-index: 111;
}

.index_body {
	padding-top: 72px;
	.title{
		font-size: 32px;
	}

	.banner_box {
		width: 100%;
		height: 100%;
		position: relative;

		.swiper-pagination {
			position: absolute;
			bottom: 16px;
			left: 50%;
			transform: translateX(-50%);
		}
	}

	.banner {
		width: 100%;
		height: 100%;
		position: relative;

		img {
			width: 100%;
			height: 100%;
		}

		.down_win {
			position: absolute;
			bottom: 18%;
			left: 27%;
			width: 216px;
			height: 52px;
			background: #ffffff;
			border-radius: 32px;
			font-size: 20px;
			font-family: MicrosoftYaHei;
			color: #9966ff;
			line-height: 52px;
			text-align: center;

			&:hover {
				color: #7733ff;
				cursor: pointer;
				text-decoration: none;
			}
		}

		.banner_btn {
				position: absolute;
				left: 19%;
				bottom: 15%;
				.btn {
					width: 205px;
					height: 62px;
					line-height: 62px;
					background: #FFFFFF;
					border-radius: 31px;
					color: #3C85F8;
					font-size: 20px;

					&:hover {
						background: #ffffff !important;
						color: #15b2ff !important;
					}
				}

				.more_btn {
					margin-left: 32px;
				}
			}
	}

	.change_list_box {
		h2{
			font-size: 32px;
font-weight: 400;
color: #131415;
line-height: 45px;
text-align: center;
margin-bottom: 64px;
		}
		background: url("../../comm/images/document-conversion/home/change_bj.png") 0 82% no-repeat;
		background-size: 100%;
		padding: 4% 0 0;
		margin-bottom: 3%;
	}

	.change_list {
		/*width: 1400px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      margin: 0 auto;*/

		.item {
			width: 24%;
			height: 232px;
			padding: 16px 28px;
			border-radius: 4px;
			border: 1px solid rgba(0, 0, 0, 0.08);
			margin: 0 0 16px;

			&:hover {
				cursor: pointer;
				box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.12);

				img {
					transform: scale(1.05);
				}

				h3 {
					color: #15b2ff;
				}
			}

			img {
				width: 80px;
				height: 80px;
				margin-bottom: 8px;
			}

			h3 {
				color: #383e45;
				line-height: 28px;
				margin-bottom: 10px;
				font-weight: 600;
			}

			p {
				font-size: 14px;
				font-weight: 400;
				color: #8b97af;
				line-height: 22px;
			}

			&.disable {
				opacity: 0.4;

				&:hover,
				&.active {
					cursor: unset;
					border: 1px solid rgba(0, 0, 0, 0.08);
				}

				img {
					opacity: 1;
				}
			}
		}
	}
	.document_box{
		margin-bottom: 70px;
		h2{
			font-size: 32px;
font-weight: 400;
color: #131415;
line-height: 45px;
position: relative;
margin-bottom: 64px;
text-align: center;
margin-top: 80px;

		}
		.box{
			width: 1255px;
			background: url(../../comm/images/document-conversion/home/document_bj.png) 0 0 no-repeat;
			background-size: 100% 100%;
			margin: 0 auto;
			padding-bottom: 83px;
			.icon{
				width: 795px;
				margin: 0 auto 121px;
				display: block;
			}
			.fonts {
      .list{
        margin-left: 203px;
		margin-bottom: 56px;
        .item{
          font-size: 20px;
margin-bottom: 23px;
font-weight: 400;
color: #131415;
line-height: 28px;
span{
  display: inline-block;
  width: 32px;
  margin-right: 33px;
  img{
    width: 100%;
  }
}
        }
      }

      .ty_btn {
        width: 130px;
        height: 38px;
        border-radius: 100px;
        border: 1px solid #14A8F0;
        font-size: 14px;
        color: #14A8F0;
line-height: 38px;
margin-left: 259px;

        &:hover {
          background: #14A8F0;
          color: #FFFFFF;
        }
      }

      p {
        font-size: 14px;
        color: #8B97AF;
        line-height: 22px;
        padding-bottom: 80px;
      }
    }
		}
	}
	.pz_box{
		.fonts{
			width: 1200px;
			background: url(../../comm/images/document-conversion/home/pz_bj.png) 0 0 no-repeat;
			background-size: 100% 100%;
			padding-left: 69px;
			h5{
				width: 53%;
				line-height: 33px;
				margin-bottom: 24px;
			}
			.list{
				width: 35%;
				.item{
					display: inline-block;
    width: auto;
	background: url(../../comm/images/document-conversion/home/pz_icon.png) 0 center no-repeat;
			background-size: 12px 12px;
			padding-left: 18px;
			margin-right: 8px;
				}
			}
		}
		
	}
}

.index_body.mobile .down_content .item {
	border: 2px solid rgba(0, 0, 0, 0.1);
}

.index_body.mobile .change_list .item {
	border: 2px solid rgba(0, 0, 0, 0.08);
}

.index_body.mobile .bottom_container .bottom_list .bottom .fonts .copy_btn {
	border: 2px solid #d7d9de;
}
</style>




// WEBPACK FOOTER //
// src/supubwps-document-conversion/pages/index.vue